export function ToSearchedContactAddress(_contactAddress: any) {
  const contactAddress = {
    addressSource: _contactAddress.addressSource,
    addressType: _contactAddress.addressType,
    branchCode: _contactAddress.branchCode,
    building: _contactAddress.building,
    contactTemplateBranchId: _contactAddress.contactTemplateBranchId,
    contactTemplateId: _contactAddress.contactTemplateId,
    country: _contactAddress.country,
    district: _contactAddress.district,
    email: _contactAddress.email,
    fax: _contactAddress.fax,
    floorNo: _contactAddress.floorNo,
    homeGroup: _contactAddress.homeGroup,
    homeNo: _contactAddress.homeNo,
    isVat: _contactAddress.isVat,
    merchantType: _contactAddress.merchantType,
    name: _contactAddress.name,
    no: _contactAddress.no,
    personalNamePrefixTypeId: _contactAddress.personalNamePrefixTypeId,
    personalNamePrefixTypeOther: _contactAddress.personalNamePrefixTypeOther,
    phone: _contactAddress.phone,
    postCode: _contactAddress.postCode,
    province: _contactAddress.province,
    road: _contactAddress.road,
    roomNo: _contactAddress.roomNo,
    soi: _contactAddress.soi,
    subDistrict: _contactAddress.subDistrict,
    taxId: _contactAddress.taxId,
    updateDateTime: _contactAddress.updateDateTime,
    website: _contactAddress.website,
    logoUrl: _contactAddress.logoUrl,
  };
  return contactAddress;
}

export function ToContactPersonDetailList(_contactPersonDetailModel: any) {
  const contactPersonList = [];
  if (_contactPersonDetailModel !== null) {
    for (let i = 0; i < _contactPersonDetailModel.length; i++) {
      const contactPersonData: any = {
        contactPersonId: _contactPersonDetailModel[i].contactPersonId,
        namePrefix: _contactPersonDetailModel[i].namePrefix,
        personalNamePrefixTypeId: _contactPersonDetailModel[i].personalNamePrefixTypeId,
        firstname: _contactPersonDetailModel[i].firstname,
        lastname: _contactPersonDetailModel[i].lastname,
        nickname: _contactPersonDetailModel[i].nickname,
        departmentName: _contactPersonDetailModel[i].departmentName,
        departmentTypeId: _contactPersonDetailModel[i].departmentTypeId,
        position: _contactPersonDetailModel[i].position,
        email: _contactPersonDetailModel[i].email,
        phone: _contactPersonDetailModel[i].phone,
        isMainPerson: _contactPersonDetailModel[i].isMainPerson,
        isArchived: _contactPersonDetailModel[i].isArchived === 0 ? true : false,
        contactSocialModel: [],
      };
      for (let count = 0; count < _contactPersonDetailModel[i].contactSocialModel.length; count++) {
        const contactSocial = {
          socialTypeId: _contactPersonDetailModel[i].contactSocialModel[count].socialTypeId,
          url: _contactPersonDetailModel[i].contactSocialModel[count].url,
        };
        contactPersonData.contactSocialModel.push(contactSocial);
      }
      contactPersonList.push(contactPersonData);
    }
    return contactPersonList;
  }
}

export function ConvertToContactList(contactList: any) {
  return contactList;
}

export function GetContactIdListForFavorite(contactIdFavoriteModel: any) {
  const contactIdList: any = [];
  if (contactIdFavoriteModel.favoriteContactIdList && contactIdFavoriteModel.favoriteContactIdList.length > 0) {
    contactIdFavoriteModel.favoriteContactIdList.forEach((contactFavorite: any) => {
      contactIdList.push(contactFavorite);
    });
  }
  if (contactIdFavoriteModel.suggestContactIdList && contactIdFavoriteModel.suggestContactIdList.length > 0) {
    contactIdFavoriteModel.suggestContactIdList.forEach((contactFavorite: any) => {
      contactIdList.push(contactFavorite);
    });
  }
  return contactIdList;
}

export function ConvertToContactDetail(_contactDetail: any) {
  const contactDetail = {
    id: _contactDetail.id,
    name: _contactDetail.name,
    isVat: _contactDetail.isVat,
    email: _contactDetail.email,
    phone: _contactDetail.phone,
    address: _contactDetail.address,
    merchantType: _contactDetail.merchantType,
    contactName: _contactDetail.contactName,
    fax: _contactDetail.fax,
    website: _contactDetail.website,
    code: _contactDetail.code,
    invoiceIncomeType: _contactDetail.invoiceIncomeType,
    invoiceIncomeValue: _contactDetail.invoiceIncomeValue,
    accountsReceivableAccountId: _contactDetail.accountsReceivableAccountId,
    invoiceExpenseType: _contactDetail.invoiceExpenseType,
    invoiceExpenseValue: _contactDetail.invoiceExpenseValue,
    accountsPayableAccountId: _contactDetail.accountsPayableAccountId,
    personalNamePrefixType: _contactDetail.personalNamePrefixType,
    personalNamePrefixOther: _contactDetail.personalNamePrefixOther,
    contactCreditLimit: _contactDetail.contactCreditLimit,
    creditLimitSettingType: _contactDetail.creditLimitSettingType,
    logoUrl: _contactDetail.logoUrl,
    taxId: _contactDetail.taxId,
    isDeleted: _contactDetail.isDeleted,
    isArchived: _contactDetail.isArchived,
    bankInformation: _contactDetail.bankInformation,
    personToContact: _contactDetail.personToContact,
    contactBranchModel: _contactDetail.contactBranchModel,
    country: _contactDetail.country,
    groupList: _contactDetail.groupList,
    contactFinanceType: _contactDetail.contactFinanceType,
  };
  return contactDetail;
}

export function ConvertToContactSearchFirst(_contactList: any) {
  const contactList = [];
  if (_contactList !== null) {
    for (let i = 0; i < _contactList.length; i++) {
      const contactData = {
        contactBranchCode: _contactList[i].contactBranchCode,
        contactCode: _contactList[i].contactCode,
        contactEmail: _contactList[i].contactEmail,
        contactFirstName: _contactList[i].contactFirstName,
        contactFullName: _contactList[i].contactFullName,
        id: _contactList[i].contactId,
        contactLastName: _contactList[i].contactLastName,
        contactName: _contactList[i].contactName,
        contactNickName: _contactList[i].contactNickName,
        contactPersonEmail: _contactList[i].contactPersonEmail,
        contactPersonPhone: _contactList[i].contactPersonPhone,
        contactPhone: _contactList[i].contactPhone,
        contactShortName: _contactList[i].contactShortName,
        contactTaxId: _contactList[i].contactTaxId,
        contactType: _contactList[i].contactType,
        contactWebsite: _contactList[i].contactWebsite,
        personalNamePrefixOther: _contactList[i].personalNamePrefixOther,
        personalNamePrefixTypeId: _contactList[i].personalNamePrefixTypeId,
      };
      contactList.push(contactData);
    }
  }
  return contactList;
}
